<template lang="pug">
  observer.hero-video.absolute.overlay(:threshold="0.25", @visible="play", @hidden="pause")
    transition-group(name="fade")
      video.absolute.overlay.object-cover.trans-quick.pointer-events-none(ref="video", :src="proxyWPURL(video.url)", loop, autoplay, muted, playsinline, @playing="loading = false", :class="{'opacity-0': loading}", :key="video.url", @contextmenu.prevent)
</template>

<script>
import Observer from '@/components/IntersectionObserver'
import { proxyWPURL } from '@/utils'
export default {
  name: 'HeroVideo',
  props: ['video'],
  data () {
    return {
      loading: true,
      proxyWPURL
    }
  },
  methods: {
    play () {
      return this.$refs.video && this.$refs.video.play()
    },
    pause () {
      return this.$refs.video && this.$refs.video.pause()
    }
  },
  components: { Observer }
}
</script>

<style>
</style>
